module.exports = __webpack_public_path__ + "img/icon-extra.65698162.svg";